var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.isActive
      ? _c(
          "div",
          {
            staticClass: "overlay-main",
            attrs: {
              id: "overlay-" + _vm.overlayId,
              role: "dialog",
              "aria-labelledby": _vm.overlayId + "-title",
              "aria-describedby": _vm.overlayId + "-description",
            },
          },
          [
            _vm.showCloseOutside
              ? _c(
                  "button",
                  {
                    staticClass: "close",
                    style: _vm.buttonStyles,
                    on: { click: _vm.closeIt },
                  },
                  [_c("div"), _vm._v(" "), _c("div")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "slot-container", style: _vm.contentStyles },
              [
                _vm.showCloseContained
                  ? _c(
                      "button",
                      {
                        staticClass: "close contained",
                        style: _vm.buttonStyles,
                        on: { click: _vm.closeIt },
                      },
                      [_c("div"), _vm._v(" "), _c("div")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("default"),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "background-cover",
              style: _vm.overlayStyles,
            }),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }